// src/icons/employeeIcons.js
import {
    User,
    Music,
    Guitar,
    Drum,
    Mic,
    Headphones,
    Palette,
    Camera,
    Video,
    Clapperboard,
    Lightbulb,
    Wrench,
    MapPin,
    Calendar,
    Star,
} from "lucide-react";

export const ICONS = {
    user: User,
    music: Music,
    guitar: Guitar,
    drum: Drum,
    mic: Mic,
    headphones: Headphones,
    palette: Palette,
    camera: Camera,
    video: Video,
    clapper: Clapperboard,
    bulb: Lightbulb,
    wrench: Wrench,
    pin: MapPin,
    calendar: Calendar,
    star: Star,
};

export const ICON_KEYS = Object.keys(ICONS);

// bezpieczny fallback
export const getIcon = (key) => ICONS[key] || User;
export default ICONS;
